import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import beforeEach from './beforeEach'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../components/LoginPage.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: () => import(/* webpackChunkName: "Clientes" */ '../views/Clientes.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/helpdesk',
    name: 'Helpdesk',
    component: () => import(/* webpackChunkName: "Helpdesk" */ '../views/Helpdesk.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/helpdesk/tickets/:ticketID/ver',
    name: 'Ticket',
    component: () => import(/* webpackChunkName: "Ticket" */ '../views/Ticket.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/helpdesk/tickets/:ticketID/editar',
    name: 'TicketEdit',
    component: () => import(/* webpackChunkName: "Ticket" */ '../views/TicketEdit.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/assinaturas-isp',
    name: 'Assinaturas',
    component: () => import(/* webpackChunkName: "Assinaturas" */ '../views/AssinaturasISP.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/assinaturas-isp/:assinaturaID/mensalidades',
    name: 'MensalidadesISP',
    component: () => import(/* webpackChunkName: "MensalidadesISP" */ '../views/MensalidadesISP.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/provisionamento-onus',
    name: 'ProvisionamentoOnus',
    component: () => import(/* webpackChunkName: "ProvisionamentoOnus */ '../views/ProvisionamentoOnus.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/provisionamento-onus/aguardando',
    name: 'OnuAguardando',
    component: () => import(/* webpackChunkName: "OnuAguardando */ '../views/OnuAguardando.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/provisionamento-onus/onus',
    name: 'Onus',
    component: () => import(/* webpackChunkName: "Onus */ '../views/Onus.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/provisionamento-onus/pre-cadastro',
    name: 'OnusPreCadastro',
    component: () => import(/* webpackChunkName: "OnusPreCadastro */ '../views/OnusPreCadastro.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/controle-patrimonial',
    name: 'ControlePatrimonial',
    component: () => import(/* webpackChunkName: "ControlePatrimonial */ '../views/ControlePatrimonial.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/controle-patrimonial/aguardando',
    name: 'OnuAguardando',
    component: () => import(/* webpackChunkName: "OnuAguardando */ '../views/OnuAguardando.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/controle-patrimonial/onus',
    name: 'Onus',
    component: () => import(/* webpackChunkName: "Onus */ '../views/Onus.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/servidores',
    name: 'Servidores',
    component: () => import(/* webpackChunkName: "Servidores" */ '../views/Servidores.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/servidores/olts/:oltID',
    name: 'ServidoresOLTManage',
    component: () => import(/* webpackChunkName: "ServidoresOLTManage" */ '../views/ServidoresOLTManage.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/servidores/olts/:oltID/placa-uplink/:placaID',
    name: 'ServidoresOLTPlacaUplink',
    component: () => import(/* webpackChunkName: "ServidoresOLTPlacaUplink" */ '../views/ServidoresOLTPlacaUplink.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/servidores/olts/:oltID/placa-uplink/:placaID/porta/:porta',
    name: 'ServidoresOLTPlacaUplinkPorta',
    component: () => import(/* webpackChunkName: "ServidoresOLTPlacaUplinkPorta" */ '../views/ServidoresOLTPlacaUplinkPorta.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/grupos-ip-pool',
    name: 'IPPoolGrupos',
    component: () => import(/* webpackChunkName: "IPPoolGrupos" */ '../views/IPPoolGrupos.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/grupos-ip-pool/:grupoID',
    name: 'IPPools',
    component: () => import(/* webpackChunkName: "IPPools" */ '../views/IPPools.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/catalogo',
    name: 'Catalogo',
    component: () => import(/* webpackChunkName: "Catalogo" */ '../views/Catalogo.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/parceiros-rede-neutra',
    name: 'ParceirosRedeNeutra',
    component: () => import(/* webpackChunkName: "ParceirosRedeNeutra" */ '../views/ParceirosRedeNeutra.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/colaboradores',
    name: 'Colaboradores',
    component: () => import(/* webpackChunkName: "Colaboradores" */ '../views/Colaboradores.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/contas-de-usuario',
    name: 'ContasDeUsuario',
    component: () => import(/* webpackChunkName: "ContasDeUsuario" */ '../views/ContasDeUsuario.vue') // lazy-loaded when the route is visited.
  },
  {
    path: '/configuracoes/helpdesk',
    name: 'ConfigHelpdesk',
    component: () => import(/* webpackChunkName: "ConfigHelpdesk" */ '../views/ConfigHelpdesk.vue') // lazy-loaded when the route is visited.
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(beforeEach)

export default router
